import { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { cx } from '@trinity/chat-components';
import {
  ColumnOrdinal,
  ColumnColor,
  ColumnTitle,
  ColumnCategory,
  ColumnStatus,
  ColumnSummary,
} from './Column';
import {
  OrderContent,
  ColorContent,
  TitleContent,
  CategoryContent,
  StatusContent,
  SummaryContent,
} from './Column/ColumnContent';
import { Cell as ColumnActions } from './Column.Actions';
import { UpdateTagContext } from './Context';
import type { TagItem } from './interfaces';
import styles from './ProjectTagRow.module.css';

interface Props {
  tag: TagItem;
}

export const ProjectTagRow = ({ tag }: Props) => {
  const params = useParams<{ projectId: string }>();
  const mutation = useContext(UpdateTagContext);

  const handleSummaryChange = (checked: boolean) => {
    mutation.mutate({
      color: tag.base.color,
      hidden: tag.hidden,
      includeSummary: checked,
      parentId: tag.parent?.id ?? null,
      tagId: tag.id,
      title: tag.base.name,
    });
  };

  const handleColorChange = (color: string) => {
    mutation.mutate({
      color,
      hidden: tag.hidden,
      includeSummary: tag.includeSummary,
      parentId: tag.parent?.id ?? null,
      tagId: tag.id,
      title: tag.base.name,
    });
  };

  return (
    <div className={cx(styles.table, styles.body, styles.row, { [styles.hidden]: tag.hidden })}>
      <ColumnOrdinal>
        <OrderContent order={tag.ordinal} />
      </ColumnOrdinal>

      <ColumnColor>
        <ColorContent
          color={tag.base.color}
          editable={true}
          onChange={handleColorChange}
        />
      </ColumnColor>

      <ColumnTitle>
        <Link to={`/projects/${params.projectId}/tags/${tag.id}`}>
          <TitleContent title={tag.base.name} />
        </Link>
      </ColumnTitle>

      <ColumnCategory>
        <CategoryContent category={tag.base.tagCategory} />
      </ColumnCategory>
      <ColumnStatus>
        <StatusContent hidden={tag.hidden} />
      </ColumnStatus>

      <ColumnSummary>
        <SummaryContent
          includeSummary={tag.includeSummary}
          onChange={handleSummaryChange}
          disabled={mutation.isPending}
        />
      </ColumnSummary>
      <ColumnActions
        hasChildren={tag.children.length > 0}
        tag={tag} />
    </div>
  );
};
